import React, { Component } from "react";
import Menu from "./includes/Menu";
import { Grid } from "../../../node_modules/@material-ui/core";

const lang = "";

class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  componentDidMount() {
    document.title = this.getLangText({
      tc: "關於我們",
      sc: "关于我们",
      en: "About Us"
    });
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  render() {
    return AboutUsJSX(this);
  }
}

const AboutUsJSX = ctx => (
  <div className={ctx.lang === "en" ? "en" : ""}>
    <Menu lang={ctx.lang} />

    <div className="main-content-container">
      <div className="main-content-inner-wrapper aboutus">
        <Grid container spacing={0}>
          <Grid item id="page-title">
            <span>
              {ctx.getLangText({
                tc: "關於我們",
                sc: "关于我们",
                en: "About Us"
              })}
            </span>
          </Grid>
        </Grid>
        <div style={{ clear: "both" }} />

        <div className="aboutus-container">
          <Grid container spacing={0}>
            <Grid item>
              <p>
                {ctx.getLangText({
                  tc: `FxHB專注於“運營+IT”的諮詢服務與實踐。公司的主要業務範圍包括：信息技術解決方案諮詢、業務運營外包諮詢和信息技術人員外包諮詢等多方面的IT諮詢服務。多年來，公司始終堅持專業、誠信、創新、實用的服務理念，服務了多家各行業的客戶。在持續服務過程中，FxHB逐步形成以互聯網信息技術驅動企業運營模式創新和管理提升的核心能力。
                  公司根植香港多年，聚集了一批具有豐富信息技術及公司運營管理經驗的專職和兼職專家隊伍，逐步與多家專業公司建立了相互信任的合作夥伴關係。我們能夠幫助客戶設計IT運營結構、職責和分工、績效標準和技能需求等，能夠為企業運營提​​升提供獨立的諮詢和培訓服務。我們能通過經驗、資源和技術，幫助企業對自己的運營體系重新進行評估和構建，以便提高運作效率和更好地響應快速變化的市場需求，並滿足未來業務發展的需要。
                  現在的時代是互聯網的時代，隨著互聯網技術的發展和進步，越來越多的行業也必須在互聯網之上運營。 FxHB將持續進步，長期致力於幫助企業進行數字化轉型升級的服務。`,
                  sc: `FxHB专注于“运营+IT”的咨询服务与实践。公司的主要业务范围包括：信息技术解决方案咨询、业务运营外包咨询和信息技术人员外包咨询等多方面的IT咨询服务。多年来，公司始终坚持专业、诚信、创新、实用的服务理念，服务了多家各行业的客户。在持续服务过程中，FxHB逐步形成以互联网信息技术驱动企业运营模式创新和管理提升的核心能力。
                  公司根植香港多年，聚集了一批具有丰富信息技术及公司运营管理经验的专职和兼职专家队伍，逐步与多家专业公司建立了相互信任的合作伙伴关系。我们能够帮助客户设计IT运营结构、职责和分工、绩效标准和技能需求等，能够为企业运营提升提供独立的咨询和培训服务。我们能通过经验、资源和技术，帮助企业对自己的运营体系重新进行评估和构建，以便提高运作效率和更好地响应快速变化的市场需求，并满足未来业务发展的需要。
                  现在的时代是互联网的时代，随着互联网技术的发展和进步，越来越多的行业也必须在互联网之上运营。FxHB将持续进步，长期致力于帮助企业进行数字化转型升级的服务。`,
                  en: ``
                })}
                {ctx.lang==="en"?(                  
                <span>
                  FxHB focuses on providing consulting services of "Operations & Information Technology“ and achieving the integration of the two. The company's main business scopes include information technology solution consulting, business operations outsourcing consulting, information technology services outsourcing as well as other various IT consulting services.
                  <br></br>
                  Over the years, the company has always adhered to the philosophy of professional, integrity, innovation and practicality, and has served thousands of clients across various industries.
                  <br></br>
                  In the process of continuous service, FxHB has gradually mastered the core expertise of driving the innovation of company operation models and of enhancing company management capabilities via internet information technology.
                  <br></br>
                  Established in Hong Kong for many years, FxHB has gathered a team of both full-time and part-time experts with extensive experience in information technology and company operation management. Together as a team, we have gradually established mutually trusted partnership with many professional companies. We can help customers design structures for IT operations, duties distribution, performance standards, skills requirements, etc. We can also provide independent consulting and training services for businesses. Through our experience, resources, and technology, we can help companies re-evaluate their existing operation systems and build new ones in order to improve the operation efficiency, respond better to the rapidly changing market demands, and to meet the needs of future business development.
                  <br></br>
                  Now is the era of the internet. With the rapid growth of the web, more and more industries will have to operate their businesses online. FxHB is committed to making continuous improvements, striving to help companies carry out the digital transformation they need.
                </span>  
                ):(<span></span>)
                }
              </p>
            </Grid>
          </Grid>

          <div className="core">
            <Grid container spacing={0} justify="center">
              <Grid item>
                <span className="core-summary theme-color">
                  {ctx.getLangText({
                    tc: "我們的使命和願景",
                    sc: "我们的使命和愿景",
                    en: "OUR MISSION, VISION "
                  })}
                </span>
              </Grid>
            </Grid>
            <Grid container spacing={0} justify="center">
              <Grid item>
                <p>
                  {ctx.getLangText({
                    tc:
                      "堅持以客戶為中心，以專業、誠信及領先技術，協助客戶取得豐盛回報",
                    sc:
                      "坚持以客户为中心，以专业、诚信及领先技术，协助客户取得丰盛回报",
                    en:
                      "Client-focused – Helping clients get optimal returns with our professionalism, integrity, and advanced technology"
                  })}
                </p>
              </Grid>
            </Grid>
          </div>

          {/* <div className="core-mission">
            <span>
              {ctx.getLangText({
                tc: "我們的使命",
                sc: "我们的使命",
                en: "OUR MISSION"
              })}
            </span>
            <p>
              {ctx.getLangText({
                tc: "專業團隊為客戶提供可靠的金融服務，為投資者創造最大價值",
                sc: "专业团队为客户提供可靠的金融服务，为投资者创造最大价值",
                en:
                  "Maximizing investment return through providing reliable financial services"
              })}
            </p>
          </div>

          <div className="core-mission">
            <span>
              {ctx.getLangText({
                tc: "我們的願景",
                sc: "我们的愿景",
                en: "OUR VISION"
              })}
            </span>
            <p>
              {ctx.getLangText({
                tc: "致力發展金融科技，成為環球主要的領先金融服務商",
                sc: "致力发展金融科技，成为环球主要的领先金融服务商",
                en:
                  "To develop fintech and become a leading world-class financial service provider"
              })}
            </p>
          </div>

          <div className="core-mission">
            <span>
              {ctx.getLangText({
                tc: "我們的價值",
                sc: "我们的价值",
                en: "OUR VALUES"
              })}
            </span>
            <p>
              {ctx.getLangText({
                tc:
                  "以公開透明和具競爭力的交易服務和多元化產品，推動金融行業改革",
                sc:
                  "以公开透明和具竞争力的交易服务和多元化产品，推动金融行业改革",
                en:
                  "Promoting reforms in financial industry with our transparent and competitive trading services and diversified products"
              })}
            </p>
          </div>
         */}
        </div>
      </div>
    </div>
  </div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/pages/AboutUs.js